export default __webpack_public_path__ + "static/media/flag-serbia.ba9d0141.svg";